import classNames from 'classnames';
import FJSideModelSelectedInputBox from '../../../../common/components/FJSideModelSelectedInputBox/FJSideModelSelectedInputBox';
import { FJVideoRemoveBgDataConfig } from '../../../../config/dataConfig/FJVideoRemoveBgDataConfig';
import FJLocalStore from '../../../../store/FJLocalStore';
import styles from './FJVideoRemoveBgFormate.module.less';
import CheckIcon from '../../../../assets/svg/choose.svg?react';
import PropTypes from 'prop-types';

const FJVideoRemoveBgFormate = ({ curExportFormate, onChange, isAutoRemoveBg }) => {
    return (
        <FJSideModelSelectedInputBox
            titleTextClassName={styles.title_text}
            title={'formate'}
            selectedName={FJLocalStore._(curExportFormate)}
            isShowArrowIcon={true}
            modelPosition={{ top: isAutoRemoveBg ? 324 : 272, left: 478 }}
            className={styles.panel_box}
        >
            <div className={styles.model_image_number_title}>{FJLocalStore._('formate')}</div>

            <div className={styles.list_box}>
                {FJVideoRemoveBgDataConfig.FORMATE_LIST.map(item => {
                    return (
                        <div
                            className={classNames(styles.item, {
                                [styles.item_active]: curExportFormate === item,
                            })}
                            key={item}
                            onClick={() => onChange(item)}
                        >
                            <div className={styles.item_text}>{FJLocalStore._(item)}</div>
                            {item === curExportFormate && <CheckIcon className={styles.check_icon} />}
                        </div>
                    );
                })}
            </div>
        </FJSideModelSelectedInputBox>
    );
};

FJVideoRemoveBgFormate.propTypes = {
    curExportFormate: PropTypes.string,
    onChange: PropTypes.func,
    isAutoRemoveBg: PropTypes.bool,
};

export default FJVideoRemoveBgFormate;
